 export const typesReguserdet = {
   
    "GET_SAVEREGUSER_SUCCESS":'GET_SAVEREGUSER_SUCCESS',
    "GET_SAVEREGUSER_ERROR":'GET_SAVEREGUSER_ERROR',
    "GET_SAVEREGUSER_BEGIN":'GET_SAVEREGUSER_BEGIN'
    
}
